var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1107_16878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1L23 23",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.33912V3.99912C15.0007 3.25514 14.725 2.53743 14.2264 1.98532C13.7277 1.4332 13.0417 1.08606 12.3015 1.01129C11.5613 0.936521 10.8197 1.13946 10.2207 1.5807C9.62172 2.02195 9.20805 2.67002 9.06 3.39912M9 8.99911V11.9991C9.00052 12.5921 9.17675 13.1716 9.50643 13.6644C9.83611 14.1573 10.3045 14.5414 10.8523 14.7683C11.4002 14.9951 12.0029 15.0545 12.5845 14.939C13.1661 14.8234 13.7005 14.5381 14.12 14.1191L9 8.99911Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 16.95C16.0237 17.9464 14.7721 18.6285 13.4056 18.9086C12.039 19.1887 10.62 19.0542 9.33044 18.5223C8.0409 17.9903 6.9397 17.0853 6.16811 15.9232C5.39652 14.761 4.98974 13.3949 4.99994 12V10M18.9999 10V12C18.9996 12.4124 18.9628 12.824 18.8899 13.23",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19V23",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 23H16",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1107_16878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.11763479dfb2b0d12951b23d3ab1970c.svg";
export { ForwardRef as ReactComponent };